import React, {useState} from "react";
import { Paths, Urls } from "./../../constants/UrlConstants";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { setUnreadMessageCount } from "../../actions/inbox/InboxActions";
import { EPDomain_ROOT } from "../../constants/EP-config";
import EPQueryParams from "../../constants/EPQueryParams";

export const mapStateToInbox = ({ policyReducer, unreadMessagesReducer }) => {
  const selectedPolicy = policyReducer.selectedPolicy;
  const messageId = unreadMessagesReducer.latestUnreadMessageId
    ? unreadMessagesReducer.latestUnreadMessageId
    : "";

  return {
    membershipNumber: selectedPolicy && selectedPolicy.MembershipNumber,
    messageId,
    selectedPolicy,
  };
};

export const Inbox = function (props) {

  const [url ,seturl] = useState(Urls.EngagementPortal[EPDomain_ROOT].messages);

  const handleCallback = (childData)=> {
    seturl(childData);
    props.history.replace(Paths.HomeRoot);
    if(window.name==="")
      {
      window.open(childData, "_blank", "noopener");
      window.name="LaunchedEP";
      }
};

  return (
    <EPQueryParams url={url} updatedURL={handleCallback}/>
    );
};
 
export default connect(mapStateToInbox, { setUnreadMessageCount })(
  withRouter(Inbox)
);
